import { useAuthState } from 'contexts/AuthProvider';
import { useFollowProfileMutation } from 'queries/profileFollow/useFollowProfileMutation';
import { useGetFollowProfileQuery } from 'queries/profileFollow/useGetFollowProfileQuery';
import { useUnFollowProfileMutation } from 'queries/profileFollow/useUnFollowProfileMutation';
import { useCallback, useEffect, useState } from 'react';
import { useShowAppPushOnBottomModal } from 'state-hooks/modal/useShowAppPushOnBottomModal';
import { NotiButton } from 'ui-components/navigations/HeaderButtons';
import { useRequestSign } from 'ui-hooks/useRequestSign';
import { showToast } from 'utils/modal';

interface FollowProfileButtonProps {
  profileId: number;
}

export const FollowProfileButton = ({ profileId }: FollowProfileButtonProps) => {
  const { isLoggedIn } = useAuthState();
  const { data } = useGetFollowProfileQuery(profileId);
  const requestSign = useRequestSign();
  const showAppPushOnBottomModal = useShowAppPushOnBottomModal('푸시로 신작 알림 받기');

  const [isFollow, setIsFollow] = useState(!!data?.isFollow);

  const { mutate: addMutate } = useFollowProfileMutation(profileId, {
    onMutate: () => setIsFollow(true),
    onError: () => {
      setIsFollow(false);
      showToast('알림 설정에 실패했어요.');
    },
  });
  const { mutate: deleteMutate } = useUnFollowProfileMutation(profileId, {
    onMutate: () => setIsFollow(false),
    onError: () => {
      setIsFollow(true);
      showToast('알림 해제에 실패했어요.');
    },
  });

  const handleClickFollow = useCallback(() => {
    if (!isLoggedIn) {
      requestSign();
      return;
    }

    if (isFollow) {
      deleteMutate();
      showToast('작가 소식 알림이 해제되었어요.');
    } else {
      addMutate();
      showToast('작가 소식 알림이 설정되었어요.', { hideCallback: showAppPushOnBottomModal });
    }
  }, [addMutate, deleteMutate, isFollow, isLoggedIn, requestSign, showAppPushOnBottomModal]);

  useEffect(() => {
    setIsFollow(!!data?.isFollow);
  }, [data?.isFollow]);

  return <NotiButton fill={isFollow} onClick={handleClickFollow} />;
};
